const RankTypeEnum = {
  CLASS: "CLASS",
  SCHOOL: "SCHOOL",
  CAMPUS: "CAMPUS",
  CITY: "CITY",
  REGION: "REGION",
  GENERAL: "GENERAL"
};

const RankTypeList = ["CLASS", "SCHOOL", "CAMPUS", "GENERAL"];

export { RankTypeList, RankTypeEnum };
